// extracted by mini-css-extract-plugin
module.exports = {"container":"market_container__2Ee6i","sidebar":"market_sidebar__gqRYp","rightsection":"market_rightsection__1J5IE"};